import { useEffect, useLayoutEffect, useState } from 'react';
import debounce from 'lodash/debounce';
const useMobile = () => {
  const [isMobile, setIsMobile] = useState(false);
  useEffect(() => {
    if (typeof window !== 'undefined') {
      if (window.innerWidth < 993) {
        setIsMobile(true);
      }
    }
  }, []);
  useLayoutEffect(() => {
    if (typeof window !== 'undefined') {
      const updateSize = () => {
        setIsMobile(window.innerWidth < 993);
      };
      window.addEventListener('resize', debounce(updateSize, 250));
      // updateSize();
      return () => window.removeEventListener('resize', updateSize);
    }
  }, []);
  return isMobile;
};
export default useMobile;